import React, { Component } from 'react'
import BoxScroll from '../../atoms/BoxScroll'
import style from './style.css'

class ListScroll extends Component {
    render() {
        return (
            <BoxScroll
            className={`${style.categoriesBox} ${style[this.props.color] || ''}`}
            height={this.props.height || '250px'}
            floating
            >
                <ul className={style.categoriesList}>
                    {this.props.children}
                </ul>
            </BoxScroll>
        )
    }
}

export default ListScroll

export class Item extends Component {
    render() {
        return (
            <li className={style.item}>
                {this.props.children}
            </li>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/molecules/ListScroll/index.js